/**
 * <s-product-gallery> — Switches the PDP main image when a thumbnail is pressed.
 *
 * Required markup:
 *   [data-gallery-slide="<media id>"] — one main-image slide per media; all but the active one are [hidden].
 *   button[data-gallery-thumb="<media id>"][aria-pressed] — thumbnail that shows the matching slide.
 */
class SProductGallery extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('click', this.#handleClick, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #handleClick = (event) => {
    if (!(event.target instanceof Element)) return;
    const thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb || !this.contains(thumb)) return;
    this.#select(thumb.dataset.galleryThumb);
  };

  #select(mediaId) {
    for (const slide of this.querySelectorAll('[data-gallery-slide]')) {
      const active = slide.dataset.gallerySlide === mediaId;
      slide.hidden = !active;
      if (!active) {
        for (const video of slide.querySelectorAll('video')) video.pause();
      }
    }
    for (const thumb of this.querySelectorAll('[data-gallery-thumb]')) {
      thumb.setAttribute('aria-pressed', String(thumb.dataset.galleryThumb === mediaId));
    }
  }
}

if (!customElements.get('s-product-gallery')) {
  customElements.define('s-product-gallery', SProductGallery);
}
